import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'campaigns',
    component: () => import(/* webpackChunkName: "about" */ '../views/CampaignListView.vue')
  },
  {
    path: '/campaigns',
    name: 'campaigns',
    component: () => import(/* webpackChunkName: "about" */ '../views/CampaignListView.vue')
  },

  {
    path: '/campaign/:id',
    name: 'Details',
    component: () => import(/* webpackChunkName: "about" */ '../views/CampaignDetailsView.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView.vue'),
  }



]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
